<template>
  <div class="app-footer-content">
    <span class="d-block mt-25">
      Tüm Hakları Saklıdır © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        :to="{ name: 'home' }"
      >Diko ®</b-link>
    </span>
    <legal-footer-links />
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import LegalFooterLinks from '@/components/legal/LegalFooterLinks.vue'

export default {
  components: {
    BLink,
    LegalFooterLinks,
  },
}
</script>

<style scoped>
.app-footer-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

@media (max-width: 767.98px) {
  .app-footer-content {
    display: block;
  }
}
</style>
